import { get } from '../apiRequest';

export const claimsReviewers = {
  get: (id: number) => get<any>(`v1/ClaimReviewers?claimId=${id}`),
};
